import React, { useState, useEffect, useReducer } from 'react';
import { useHistory } from 'react-router-dom';
import axios from 'axios';

const apiReducer = (state, action) => {
  switch (action.type) {
    case 'INIT':
      return {
        ...state,
        isLoading: true,
        isError: false,
      };
    case 'SUCCESS':
      return {
        ...state,
        isLoading: false,
        isError: false,
        data: action.payload,
      };
    case 'FAILURE':
      return {
        ...state,
        isLoading: false,
        isError: true,
      };
    default:
      throw new Error();
  }
};

const useApi = () => {
  const history = useHistory();
  let BASE_URL;
  let clientId;
  if (window.location.hostname.includes('localhost')) {
    // BASE_URL = 'http://localhost:7000';
    BASE_URL = 'https://api.qa.tagntrac.io';
    clientId = 'T0ia5s2bhrac';
  } else if (window.location.hostname.includes('dev')) {
    // BASE_URL = 'http://api.dev.tagntrac.io';
    BASE_URL = 'https://tnt-core-api.herokuapp.com';
    clientId = 'Tczabtzc0rac';
  } else if (window.location.hostname.includes('qa')) {
    BASE_URL = 'https://api.qa.tagntrac.io';
    clientId = 'Tzej0fe2trac';
  } else if (window.location.hostname.includes('demo')) {
    BASE_URL = 'https://api.qa.tagntrac.io';
    clientId = 'Tgnztm9b8rac';
  } else if (window.location.hostname.includes('web.app')) {
    BASE_URL = 'https://tnt-core-api.herokuapp.com';
    clientId = 'Tkvm16bsbrac';
  } else {
    BASE_URL = 'https://api.tagntrac.io';
    clientId = 'T0ia5s2bhrac';
  }

  const user = localStorage.getItem('user');
  const currentTime = Math.floor(Date.now() / 1000);
  if (user) {
    const tokenExpired = currentTime > JSON.parse(localStorage.user).expiration;
    if (tokenExpired) {
      localStorage.clear();
      history.replace('/');
    }
  }

  const [url, setUrl] = useState('');
  const [data, setData] = useState(null);
  const [method, setMethod] = useState('');

  const [state, dispatch] = useReducer(apiReducer, {
    isLoading: false,
    isError: false,
    data,
  });

  const setApiRequest = (url, method, data = null) => {
    let _url = url;
    if (_url === '/login') {
      _url = `${_url}?clientId=${clientId}`;
    }
    setMethod(method);
    setData(data);
    setUrl(BASE_URL + _url);
  };

  useEffect(() => {
    let didCancel = false;

    const callApi = async () => {
      dispatch({ type: 'INIT' });
      try {
        if (url.includes('/login') || url.includes('/confirmPassword') || url.includes('/resetPassword')) {
          const result = await axios({
            method,
            url,
            data,
            headers: {
              'Access-Control-Allow-Origin': '*',
            },
          });

          if (!didCancel) {
            dispatch({ type: 'SUCCESS', payload: result.data });
          }
        } else {
          const result = await axios({
            method,
            url,
            data,
            headers: {
              Authorization: JSON.parse(localStorage.user).token,
              'Access-Control-Allow-Origin': '*',
              'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, PATCH, OPTIONS',
            },
          });
          if (!didCancel) {
            dispatch({ type: 'SUCCESS', payload: result.data });
          }
        }
      } catch (error) {
        if (!didCancel) {
          dispatch({ type: 'FAILURE' });
        }
      }
      setMethod('');
      setData(null);
      setUrl('');
    };

    if (url && method) callApi();

    return () => {
      didCancel = true;
    };
  }, [url, method, data]);

  return [state, setApiRequest];
};

export default useApi;
